function transformToOrderItems(items) {
  return items.map(() => ({}));
}

export default transformToOrderItems;
